import axios, { RawAxiosRequestHeaders } from 'axios'
import { getUrl } from '@reapitform/hooks'

export enum displayViewMap {
  'welcome' = 'Welcome',
  'step' = 'Step',
  'submitted' = 'Congratulations',
  'inactiveLink' = 'LinkInactive',
  'changeRequest' = 'ChangesRequested',
  'error' = 'Error',
}
export interface IFormDocumentData {
  documentId: string
  recipientId: string
  formDisplayName: string
  agentLogoUrl: string
  recipientFirstName: string
  documentDisplayShortAddress: string
  agencyName: string
  agencyDisplayContactNumber: string
  totalSteps: number
  nextStep: number
  displayView: string
  changeRequests: string[]
}

export const getDocumentData = async (recipientId?: string) => {
  const url = getUrl(`/api/recipient/${recipientId}/Document`)()
  const reqHeaders: Partial<RawAxiosRequestHeaders> = { Accept: 'application/json' }

  const req = await axios.get<IFormDocumentData>(url, {
    headers: reqHeaders,
  })
  return req.data
}
